import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import { llmThreadLiteSchema } from "@redotech/redo-model/agents/llm-thread-lite";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getLlmThread = {
  name: "getLlmThread" as const,
  input: z.object({ llmThreadId: zExt.objectId() }),
  output: z
    .object({ thread: llmThreadLiteSchema, messages: z.array(MessageSchema) })
    .nullable(),
};
